export const validateEnumType = (typeName, enumList) => {
    if (typeName && enumList && !enumList.includes(typeName)) {
        console.error(`Invalid => "${typeName}". Supported are: [${enumList.join("], [")}]`);
    }
}
